<template>
    <kgr-generic-modal
        :value="show"
        :headline="headline || $t('warning')"
        @close="onCancelButtonClick"
    >
        <div class="kgr-readingBlock">
            <slot></slot>
        </div>
        <template #footer>
            <kgr-button
                value="Ok"
                @click="onOkButtonClick"
            />
            <kgr-button
                type="grey"
                :value="$t('cancel')"
                @click="onCancelButtonClick"
            />
        </template>
    </kgr-generic-modal>
</template>

<script>
import GenericModal from './GenericModal';
import KgrButton from '../form/button/KgrButton';

export default {
    components: {
        'kgr-generic-modal': GenericModal,
        'kgr-button': KgrButton,
    },
    props: {
        headline: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            show: false,
            resolve: null
        }
    },
    methods: {
        open() {
            return new Promise(resolve => {
                this.resolve = resolve;
                this.show = true;
            })
        },
        onOkButtonClick() {
            this.show = false;
            this.resolve && this.resolve(true);
        },
        onCancelButtonClick() {
            this.show = false;
            this.resolve && this.resolve(false);
        },
    },
}
</script>
